module.exports = __webpack_public_path__ + "img/16l010-02.c8d20abd.jpg";